import { CloseOutlined } from '@ant-design/icons';
import cn from 'classnames';
import * as React from 'react';

import {
  ActionKind,
  ActionParams,
  BaseClickable,
} from 'components/ui/BaseClickable';

import s from './DrawerHeader.module.scss';

type DrawerHeaderProps = {
  onClose: VoidFunction;
  title: React.ReactNode;
  extra?: React.ReactNode;
  className?: string;
};

const DrawerHeader = React.forwardRef<HTMLElement, DrawerHeaderProps>(
  (
    { onClose, title, extra, className }: DrawerHeaderProps,
    ref: React.ForwardedRef<HTMLElement>
  ) => {
    const closeAction: ActionParams = React.useMemo(
      () => ({
        actionKind: ActionKind.button,
        complexOnClick: {
          onClick: onClose,
        },
      }),

      [onClose]
    );

    return (
      <header ref={ref} className={cn(s.header, className)}>
        <BaseClickable
          withHover
          withCursorPointer
          className={s.header__close}
          action={closeAction}
        >
          <CloseOutlined />
        </BaseClickable>
        <div className={s.header__title}>{title}</div>
        <div className={s.header__extra}>{extra}</div>
      </header>
    );
  }
);

export default DrawerHeader;
